export const intlMessagesId = {
  'page.notFound': 'Halaman tidak ditemukan.',

  'project.title': 'Jumpstart Portal Frontend'
};
